import {
    DASHBOARD_CHART_INTERVAL_DAILY,
    DASHBOARD_CHART_INTERVAL_MONTHLY,
    DASHBOARD_CHART_INTERVAL_YEARLY,
    DASHBOARD_CHART_MODULE_OWNERS
} from '../../../constants';

export const GRID_LAYOUT_COL_NUM = 12;
export const GRID_LAYOUT_ROW_HEIGHT = 25;
export const GRID_LAYOUT_HORIZONTAL_MARGIN = 15;
export const GRID_LAYOUT_VERTICAL_MARGIN = 15;

const ADMIN_BOOKINGS_CHART_SYSNAME = 'ADMIN_BOOKINGS_CHART';
const ADMIN_BOOKING_REVENUE_CHART_SYSNAME = 'ADMIN_BOOKING_REVENUE_CHART';
const ADMIN_ISSUED_POLICIES_CHART_SYSNAME = 'ADMIN_ISSUED_POLICIES_CHART';
const ADMIN_LAPSED_SUBSCRIBERS_TABLE_SYSNAME = 'ADMIN_LAPSED_SUBSCRIBERS_TABLE';
const ADMIN_NEW_SUBSCRIBERS_TABLE_SYSNAME = 'ADMIN_NEW_SUBSCRIBERS_TABLE';
const ADMIN_SUBSCRIPTION_REVENUE_CHART_SYSNAME = 'ADMIN_SUBSCRIPTION_REVENUE_CHART';
const ADMIN_TRIAL_SUBSCRIBERS_CHART_SYSNAME = 'ADMIN_TRIAL_SUBSCRIBERS_CHART';
const ADMIN_PAID_SUBSCRIBERS_CHART_SYSNAME = 'ADMIN_PAID_SUBSCRIBERS_CHART';
const ADMIN_CHANNEX_USAGE_CHART_SYSNAME = 'ADMIN_CHANNEX_USAGE_CHART';
const AIRBNB_SYNC_ERRORS_TABLE_SYSNAME = 'AIRBNB_SYNC_ERRORS_TABLE';
const BALANCES_DUE_RESERVATIONS_TABLE_SYSNAME = 'BALANCES_DUE_RESERVATIONS_TABLE';
const DEPARTURES_CHART_SYSNAME = 'DEPARTURES_CHART';
const GUEST_EMAIL_BOUNCES_TABLE_SYSNAME = 'GUEST_EMAIL_BOUNCES_TABLE';
const ICALENDAR_CONFLICTS_TABLE_SYSNAME = 'ICALENDAR_CONFLICTS_TABLE';
const TODOS_SYSNAME = 'TODOS';
const NOTES_SYSNAME = 'NOTES';
const INQUIRIES_CHART_SYSNAME = 'INQUIRIES_CHART';
const CANCELLATIONS_TABLE_SYSNAME = 'CANCELLATIONS_TABLE';
const FAILED_TRANSACTIONS_TABLE_SYSNAME = 'FAILED_TRANSACTIONS_TABLE';
const GUEST_TRANSACTIONS_TABLE_SYSNAME = 'GUEST_TRANSACTIONS_TABLE';
const INQUIRIES_TABLE_SYSNAME = 'INQUIRIES_TABLE';
const PENDING_RESERVATIONS_TABLE_SYSNAME = 'PENDING_RESERVATIONS_TABLE';
const REFUND_DUE_RESERVATIONS_TABLE_SYSNAME = 'REFUND_DUE_RESERVATIONS_TABLE'
const RESERVATIONS_CHART_SYSNAME = 'RESERVATIONS_CHART'
const ARRIVALS_STATISTICS_CHART_SYSNAME = 'ARRIVALS_STATISTICS_CHART';
const WEATHER_SYSNAME = 'WEATHER';
const STATISTICS_SYSNAME = 'STATISTICS';
const BOOKING_METHOD_CHART_SYSNAME = 'BOOKING_METHOD_CHART';
const ALL_ARRIVALS_TABLE_SYSNAME = 'ALL_ARRIVALS_TABLE'
const ALL_DEPARTURES_TABLE_SYSNAME = 'ALL_DEPARTURES_TABLE'
const ADMIN_AVERAGE_TRIP_DURATION_CHART_SYSNAME = 'ADMIN_TRIP_DURATION_CHART'
const STAYLIO_INSTALL_BASE_CHART_SYSNAME = 'STAYLIO_INSTALL_BASE_CHART'
const STAYLIO_ADOPTION_RATE_CHART_SYSNAME = 'STAYLIO_ADOPTION_RATE_CHART'
const STAYLIO_INSTALL_BASE_HISTORY_CHART_SYSNAME = 'STAYLIO_INSTALL_BASE_HISTORY_CHART'
const STAYLIO_PUSH_NOTIFICATION_METRICS_CHART_SYSNAME = 'STAYLIO_PUSH_NOTIFICATION_METRICS_CHART'


export const WIDGET_SYSNAME_COMPONENT_NAME_MAPPING = Object.freeze({
    [ADMIN_BOOKINGS_CHART_SYSNAME]:
        'bookings-chart-card-grid-item',
    [ADMIN_BOOKING_REVENUE_CHART_SYSNAME]:
        'booking-revenue-chart-card-grid-item',
    [ADMIN_ISSUED_POLICIES_CHART_SYSNAME]:
        'issued-policies-chart-card-grid-item',
    [ADMIN_LAPSED_SUBSCRIBERS_TABLE_SYSNAME]:
        'lapsed-subscribers-table-card-grid-item',
    [ADMIN_NEW_SUBSCRIBERS_TABLE_SYSNAME]:
        'new-subscribers-table-card-grid-item',
    [ADMIN_SUBSCRIPTION_REVENUE_CHART_SYSNAME]:
        'subscription-revenue-chart-card-grid-item',
    [ADMIN_TRIAL_SUBSCRIBERS_CHART_SYSNAME]:
        'trial-subscribers-chart-card-grid-item',
    [ADMIN_PAID_SUBSCRIBERS_CHART_SYSNAME]:
        'paid-subscribers-chart-card-grid-item',
    [AIRBNB_SYNC_ERRORS_TABLE_SYSNAME]:
        'airbnb-sync-errors-table-card-grid-item',
    [ADMIN_CHANNEX_USAGE_CHART_SYSNAME]:
        'channex-usage-chart-card-grid-item',        
    [BALANCES_DUE_RESERVATIONS_TABLE_SYSNAME]: 'balances-due-reservations-table-card-grid-item',
    [DEPARTURES_CHART_SYSNAME]: 'departures-chart-card-grid-item',
    [CANCELLATIONS_TABLE_SYSNAME]: 'cancellations-table-card-grid-item',
    [FAILED_TRANSACTIONS_TABLE_SYSNAME]: 'failed-transactions-table-card-grid-item',
    [GUEST_TRANSACTIONS_TABLE_SYSNAME]: 'guest-transactions-table-card-grid-item',
    [GUEST_EMAIL_BOUNCES_TABLE_SYSNAME]:
        'guest-email-bounces-table-card-grid-item',
    [ICALENDAR_CONFLICTS_TABLE_SYSNAME]:
        'i-calendar-conflicts-table-card-grid-item',
    [TODOS_SYSNAME]: 'todo-list-card-grid-item',
    [NOTES_SYSNAME]: 'note-list-card-grid-item',
    [INQUIRIES_CHART_SYSNAME]: 'inquiries-chart-card-grid-item',
    [INQUIRIES_TABLE_SYSNAME]: 'inquiries-table-card-grid-item',
    [PENDING_RESERVATIONS_TABLE_SYSNAME]: 'pending-reservations-table-card-grid-item',
    [RESERVATIONS_CHART_SYSNAME]:
        'reservations-pie-chart-table-card-grid-item',
    [REFUND_DUE_RESERVATIONS_TABLE_SYSNAME]: 'refund-due-reservations-table-card-grid-item',
    [ARRIVALS_STATISTICS_CHART_SYSNAME]:
        'arrivals-statistics-pie-chart-card-grid-item',
    [WEATHER_SYSNAME]: 'weather-card-grid-item',
    [STATISTICS_SYSNAME]: 'statistics-card-grid-item',
    [BOOKING_METHOD_CHART_SYSNAME]: 'booking-method-chart-card-grid-item',
    [ALL_ARRIVALS_TABLE_SYSNAME]: 'all-arrivals-table-card-grid-item',
    [ALL_DEPARTURES_TABLE_SYSNAME]: 'all-departures-table-card-grid-item',
    [ADMIN_AVERAGE_TRIP_DURATION_CHART_SYSNAME]: 'average-trip-duration-chart-card-grid-item',
    [STAYLIO_INSTALL_BASE_CHART_SYSNAME]: 'staylio-install-base-chart-card-grid-item',
    [STAYLIO_ADOPTION_RATE_CHART_SYSNAME]: 'staylio-adoption-rate-chart-card-grid-item',
    [STAYLIO_INSTALL_BASE_HISTORY_CHART_SYSNAME]: 'staylio-install-base-history-chart-card-grid-item',
    [STAYLIO_PUSH_NOTIFICATION_METRICS_CHART_SYSNAME]: 'staylio-push-notification-metrics-chart-card-grid-item',
});

export const renderGuestStatusIcon = status => {
    const statusImageSrc = status.is_vip
        ? '/static/images/icons/reservation/vip_bg_24.svg'
        : status.is_blocklist
        ? '/static/images/icons/reservation/blocklist_bg_24.svg'
        : null;
    if (status && statusImageSrc) {
        return `<img class="dashboard-guest-status-icon" title="${status.name}" src="${statusImageSrc}" />`;
    }
};

export const generateWidgetID = () => {
    return (Math.random() * 1e128).toString(12);
};

export const getWidgetMinHeightBySysname = sysname => {
    switch (sysname) {
        case ADMIN_LAPSED_SUBSCRIBERS_TABLE_SYSNAME:
        case ADMIN_NEW_SUBSCRIBERS_TABLE_SYSNAME:
        case AIRBNB_SYNC_ERRORS_TABLE_SYSNAME:
        case GUEST_EMAIL_BOUNCES_TABLE_SYSNAME:
        case ICALENDAR_CONFLICTS_TABLE_SYSNAME:
        case INQUIRIES_TABLE_SYSNAME:
        case BALANCES_DUE_RESERVATIONS_TABLE_SYSNAME:
        case PENDING_RESERVATIONS_TABLE_SYSNAME:
        case REFUND_DUE_RESERVATIONS_TABLE_SYSNAME:
        case ALL_ARRIVALS_TABLE_SYSNAME:
        case ALL_DEPARTURES_TABLE_SYSNAME:
            return 8;
        case ADMIN_BOOKINGS_CHART_SYSNAME:
        case ADMIN_BOOKING_REVENUE_CHART_SYSNAME:
        case ADMIN_ISSUED_POLICIES_CHART_SYSNAME:
        case ADMIN_CHANNEX_USAGE_CHART_SYSNAME:
        case INQUIRIES_CHART_SYSNAME:
        case ADMIN_SUBSCRIPTION_REVENUE_CHART_SYSNAME:
        case ADMIN_TRIAL_SUBSCRIBERS_CHART_SYSNAME:
        case ADMIN_PAID_SUBSCRIBERS_CHART_SYSNAME:        
        case DEPARTURES_CHART_SYSNAME:
        case ADMIN_AVERAGE_TRIP_DURATION_CHART_SYSNAME:
            return 13;
        case BOOKING_METHOD_CHART_SYSNAME:
            return 16;
        case TODOS_SYSNAME:
        case NOTES_SYSNAME:
            return 10;
        case FAILED_TRANSACTIONS_TABLE_SYSNAME:
        case GUEST_TRANSACTIONS_TABLE_SYSNAME:
        case CANCELLATIONS_TABLE_SYSNAME:
        case WEATHER_SYSNAME:
            return 11;
        case RESERVATIONS_CHART_SYSNAME:
        case ARRIVALS_STATISTICS_CHART_SYSNAME:
            return 11;
        case STATISTICS_SYSNAME:
            return 5;
        case STAYLIO_INSTALL_BASE_CHART_SYSNAME:
            return 12;
        case STAYLIO_ADOPTION_RATE_CHART_SYSNAME:
            return 13;
        case STAYLIO_INSTALL_BASE_HISTORY_CHART_SYSNAME:
            return 13;
        case STAYLIO_PUSH_NOTIFICATION_METRICS_CHART_SYSNAME:
            return 13;
        default:
            return 5;
    }
};

const _getWidgetCardHeight = tabWidget => {
    return Math.round(
        GRID_LAYOUT_ROW_HEIGHT * tabWidget.h +
            Math.max(0, tabWidget.h - 1) * GRID_LAYOUT_VERTICAL_MARGIN
    );
};

export const getWidgetGridRowsNumber = ({ tabWidget, extraHeight = null }) => {
    const cardHeightPx = _getWidgetCardHeight(tabWidget);
    const cardHeaderHeightPx = 78;
    const cardGridHeaderHeightPx = 36;
    const cardGridPaginationHeightPx = 48;

    let cardGridBodyHeightPx =
        cardHeightPx -
        cardHeaderHeightPx -
        cardGridHeaderHeightPx -
        cardGridPaginationHeightPx;

    if (extraHeight) {
        cardGridBodyHeightPx = cardGridBodyHeightPx - extraHeight;
    }

    const _cardGridRowHeight = 28;
    return Math.floor(cardGridBodyHeightPx / _cardGridRowHeight);
};

export const getWidgetTodoListRowsNumber = ({ tabWidget }) => {
    const cardHeightPx = _getWidgetCardHeight(tabWidget);
    const cardHeaderHeightPx = 78;
    const cardSearchBarHeightPx = 63.5;
    const cardGridPaginationHeightPx = 47;

    const cardGridBodyHeightPx =
        cardHeightPx -
        cardHeaderHeightPx -
        cardSearchBarHeightPx -
        cardGridPaginationHeightPx;

    const _cardGridRowHeight = 52;

    return Math.floor(cardGridBodyHeightPx / _cardGridRowHeight);
};

export const getApexChartsGradientFill = ({ gradient = {} } = {}) => ({
    type: 'gradient',
    gradient: {
        shadeIntensity: 0.85,
        opacityFrom: 0.35,
        opacityTo: 0.55,
        stops: [0, 90, 100],
        ...gradient
    }
});

export const getApexChartsAmountFormat = (val) => {
    if (val >= 1000000) {
        val = val / 1000000 + 'M';
    }
    else if (val >= 1000) {
        val = val / 1000 + 'K';
    }
    return `$${val}`;
};

export const getApexChartsDateFormatBasedOnInterval = (interval) =>
    interval === DASHBOARD_CHART_INTERVAL_DAILY
        ? 'MMM dd'
        : interval === DASHBOARD_CHART_INTERVAL_MONTHLY
            ? 'MMM yyyy'
            : 'yyyy';

const RED = 'RED';
const ORANGE = 'ORANGE';
const GREEN = 'GREEN';

const tagsColors = Object.freeze({
    [RED]: 'RED',
    [ORANGE]: 'ORANGE',
    [GREEN]: 'GREEN',
});

export const getTagsStyles = color => {
    switch (color) {
        case tagsColors[RED]:
            return { color: '#ea5455', backgroundColor: 'rgba(234,84,85,.12)' };
        case tagsColors[ORANGE]:
            return {
                color: '#FF9F43',
                backgroundColor: 'rgba(255,159,67,.12)',
            };
        case tagsColors[GREEN]:
            return {
                color: '#28C76F',
                backgroundColor: 'rgba(40,199,111,.12)',
            };
    }
};

export const STANDARD = 'STANDARD';
export const METRIC = 'METRIC';
export const IMPERIAL = 'IMPERIAL';

export const weatherUnits = Object.freeze({
    [STANDARD]: 'standard',
    [METRIC]: 'metric',
    [IMPERIAL]: 'imperial',
});

export const headerStyleClasses = [
    'grid-card-header--default',
    'grid-card-header--primary',
    'grid-card-header--danger',
    'grid-card-header--success',
    'grid-card-header--blue',
    'grid-card-header--cyan',
    'grid-card-header--pink',
    'grid-card-header--orange',
]

export const renderReservationIdColumn = data => {
    return data && data.reservation.is_blocked
        ? 'Owner Block'
        : `<a href="/app/reservation/edit/invoice/${data.reservation.id}">${data.reservation.id}</a>`;
};

export const DEFAULT_DASHBOARD_CHART_INTERVAL = DASHBOARD_CHART_INTERVAL_DAILY;
export const DEFAULT_DASHBOARD_CHART_MODULE = DASHBOARD_CHART_MODULE_OWNERS;

export const getDefaultChartPeriodBasedOnInterval = (interval) =>
    interval === DASHBOARD_CHART_INTERVAL_YEARLY
        ? 4
        : interval === DASHBOARD_CHART_INTERVAL_MONTHLY
            ? 6
            : 1;
